import Loader from "../utils/Loader";
import { useState, useRef } from 'react';
import moment from "moment";
import { userManualDownloadUrl, disclaimer } from '../utils/constants';
import { useNavigate, Link } from "react-router-dom";


const VisitorHeader = () => {
    const navigate = useNavigate();

    const [isLoading, setLoader] = useState(false);
    const marqueeRef = useRef(null);

    // Exhibition From Date
    const dateString = sessionStorage.getItem('exhibitionDateFrom');
    const dateStringMoment = moment.utc(dateString, "DD/MM/YYYY").format('DD MMMM YYYY')
    const dateObject = new Date(dateStringMoment);
    const fromDay = dateObject.getDate();
    const fromMonth = dateObject.toLocaleString('default', { month: 'long' });
    const fromYear = dateObject.getFullYear();
    const fromDate = `${fromDay} ${fromMonth} ${fromYear}`;
    console.log('dateString', dateString)
    console.log('dateStringMoment', dateStringMoment)
    console.log('dateObject', dateObject)

    // Exhibition to Date
    const dateString1 = sessionStorage.getItem('exhibitionDateTo');
    const dateString1Moment = moment.utc(dateString1, "DD/MM/YYYY").format('DD MMMM YYYY')
    const dateObject1 = new Date(dateString1Moment);
    const toDay = dateObject1.getDate();
    const toMonth = dateObject1.toLocaleString('default', { month: 'long' });
    const toYear = dateObject1.getFullYear();
    const toDate = `${toDay} ${toMonth} ${toYear}`;

    // Exhibition Logo File Path
    const logoPath = sessionStorage.getItem('sessionLogoPath')
    const ExhibitionEmail = JSON.parse(sessionStorage.getItem('sessionExhibitionEmail'))
    const ExhibitionMobileNo = JSON.parse(sessionStorage.getItem('sessionExhibitionMobileNo'))

    // Exhibition Address
    const address = sessionStorage.getItem('exhibitionAddress')

    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
    };

    const onLogoutClick = () => {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/login");
    };

    const corporateLink = sessionStorage.getItem("sessionExhMailWebsite") || "https://corporate.india-itme.com";

    return (
        <>
            {isLoading ? (
                <Loader></Loader>
            ) : (
                null
            )}

            {isMobileMenuOpen && (
                <div
                    className="mobile-menu-overlay exhibitor-mobile-overlay"
                    onClick={closeMobileMenu}
                ></div>
            )}


            <div
                className={`mobile-sidebar-menu exhibitor-mobile-menu ${isMobileMenuOpen ? "mobile-menu-open" : ""
                    }`}
            >
                <div className="mobile-menu-header exhibitor-menu-header">
                    <button
                        onClick={closeMobileMenu}
                        className="exhibitor-menu-close-btn text-white"
                    >
                        ×
                    </button>
                    <div className="user-info exhibitor-user-info">
                        <h4 className="text-uppercase fw-semibold text-white fw-bold">
                            {sessionStorage.getItem("sessionExhibitionName")}
                        </h4>
                    </div>
                </div>
                <div className="mobile-menu-content exhibitor-menu-content">
                    <div className="menu-section exhibitor-details-section">
                        <h6 class="exhibitor-section-title text-center border-bottom-0">Owned and Organised by</h6>
                        <a style={{ width: '150px' }} href="index.html">
                            <img src="../images/itme-right-logo.png" className="header-brand-img desktop-logo" alt="logo" />
                        </a>
                    </div>

                    <div className="menu-section exhibitor-details-section">
                        <h6 className="exhibitor-section-title">Exhibition Details</h6>
                        <p className="exhibitor-detail-text mb-2">
                            {sessionStorage.getItem("exhibitionDateFrom")} -{" "}
                            {sessionStorage.getItem("exhibitionDateTo")} <br />
                            {address}
                        </p>
                    </div>

                    <div className="menu-section exhibitor-details-section">
                        <h6 className="exhibitor-section-title">For Assistance</h6>
                        <p className="exhibitor-detail-text mb-2">
                            {ExhibitionMobileNo} <br />
                            {ExhibitionEmail} <br />
                        </p>
                    </div>

                    <div className="menu-section exhibitor-links-section">
                        <h6 className="exhibitor-section-title gap-1">Quick Links</h6>
                        <a
                            href={corporateLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="exhibitor-menu-link mb-2 mobi"
                            onClick={closeMobileMenu}
                        >
                            For new corporate site please <span className="text-primary ms-1"> Click here</span>
                        </a>

                    </div>
                </div>
            </div>

            <div className="app-header header sticky app-heder-with-logo">
                <div className="container-fluid main-container pe-2">
                    <div className="d-flex mt-1 mt-lg-0">
                        {/* <a className="logo-horizontal " href="index.html">
                            <img
                                src={logoPath} className="header-brand-img desktop-logo" alt="logo" />
                        </a> */}
                        <div className="d-flex">
                            <a className="logo-horizontal " href="index.html">
                                <img
                                    src={logoPath} className="header-brand-img desktop-logo" alt="logo" />
                            </a>
                            <div class="side-header">
                                {/* <a class="header-brand1" >
                                     <img src={logoPath} class="header-brand-img header-brand-img-1 light-logo1" alt="top-left logo" />
                                 </a> */}
                                <div class="side-header">
                                    <a class="header-brand1" >
                                        <img src={logoPath} class="header-brand-img header-brand-img-1 light-logo1 m-0" alt="top-left logo" />
                                    </a>
                                </div>

                                {/* <p className=" header-assistance text-white">
                                     For Assistance
                                     <br>
                                     </br>
                                     {ExhibitionMobileNo.length > 0 ? ExhibitionMobileNo.map((data, i) => (<>
                                         {data}{i != ExhibitionMobileNo.length - 1 ? ',' : null}
                                     </>
                                     )) : null}
                                     <br>
                                     </br>
                                     {ExhibitionEmail.length > 0 ? ExhibitionEmail.map((data, i) => (
                                         <a href={data} > {data} {i != ExhibitionEmail.length - 1 ? '/' : null} </a>
                                     )) : null}
                                 </p> */}


                                {/* <div class="right-logo">
                <p className='right-logo-text' style={{ top: '20px' }}>Owned and Organised by</p>
                <img src="../images/itme-right-logo.png" className="header-brand-img desktop-logo" alt="logo" />
              </div> */}

                            </div>
                            <p className=" header-logo-name" >{fromDate} - {toDate} <br></br>
                                {address}
                            </p>
                            <p className=" header-assistance" style={{ width: '25rem',marginTop:'-15px' }}>
                                For Assistance
                                <br>
                                </br>
                                {ExhibitionMobileNo.length > 0 ? ExhibitionMobileNo.map((data, i) => (<>
                                    {data}{i != ExhibitionMobileNo.length - 1 ? ',' : null}
                                </>
                                )) : null}
                                <br>
                                    {/* ` ${(data)}`(i != ExhibitionMobileNo.length - 1 ? ',' : null) */}
                                </br>
                                {ExhibitionEmail.length > 0 ? ExhibitionEmail.map((data, i) => (
                                    <a href={data} > {data} {i != ExhibitionEmail.length - 1 ? '/' : null} </a>
                                )) : null}
                            </p>


                            <div class="right-logo">
                                <p className='right-logo-text' style={{ top: '20px' }}>Owned and Organised by</p>
                                <img src="../images/itme-right-logo.png" className="header-brand-img desktop-logo" alt="logo" />
                            </div>

                        </div>
                        {/* <p className="header-logo-name text-white" >{fromDate} - {toDate} <br></br>
                            {address}
                        </p> */}
                        {/* <p className="header-logo-name text-white">
                            {fromDate} - {toDate}
                            <br />
                            {address && (
                                <>
                                    {address.slice(0, 45)}
                                    <br />
                                    {address.slice(45)}
                                </>
                            )}
                        </p> */}


                        {/* <div class="right-logo">
                            <p className='right-logo-text text-nowrap text-white' style={{ top: '8px' }}>Owned and Organised by</p>
                            <p className=" header-assistance text-white text-nowrap">
                                For Assistance &nbsp;
                                {ExhibitionMobileNo.length > 0 ? ExhibitionMobileNo.map((data, i) => (<>
                                    {data}{i != ExhibitionMobileNo.length - 1 ? ',' : null}
                                </>
                                )) : null}
                                <br>
                                </br>
                                {ExhibitionEmail.length > 0 ? ExhibitionEmail.map((data, i) => (
                                    <a href={data} > {data} {i != ExhibitionEmail.length - 1 ? '/' : null} </a>
                                )) : null}
                            </p>
                            <img src="../images/itme-right-logo.png" className="header-brand-img desktop-logo" alt="logo" />
                        </div> */}

                    </div>
                    <div
                        className="marquee-text"
                        style={{
                            marginTop: window.innerWidth <= 991 ? '0px' : '-17px'
                        }}
                    >

                        <marquee
                            behavior="scroll"
                            direction="left"
                            scrollamount="5"
                            ref={marqueeRef}
                            onMouseOver={() => marqueeRef.current?.stop()}
                            onMouseOut={() => marqueeRef.current?.start()}
                        >
                            <b>Disclaimer and Ownership:</b> {disclaimer}
                        </marquee>
                    </div>
                </div>

                <div className="mobile-toggle exhibitor-mobile-toggle d-lg-none pe-3">
                    <button
                        onClick={toggleMobileMenu}
                        className="exhibitor-menu-toggle-btn"
                    >
                        <span className="exhibitor-menu-toggle-bar"></span>
                        <span className="exhibitor-menu-toggle-bar"></span>
                        <span className="exhibitor-menu-toggle-bar"></span>
                    </button>
                </div>
            </div>


        </>
    )
}

export default VisitorHeader;